import React from 'react';
import { Select } from 'antd';
import { cleanParallel } from './scheduleTimeline';
import { newId } from './scheduleTimes';

export function groupActivity(entries, id, targetId) {
  const target = entries.find(e => e.id === targetId);
  const group = target?.parallelGroupId || (target ? newId() : undefined);
  return cleanParallel(entries.map(e => {
    if(e.id !== id && e.id !== targetId) return e;
    const next = { ...e };
    if(group) next.parallelGroupId = group; else delete next.parallelGroupId;
    return next;
  }));
}
export default function ScheduleParallelControl({ entry, entries, disabled, onChange, protectedIds = new Set() }) {
  if(entry.kind !== 'activity') return null;
  const peer = entries.find(e => e.id !== entry.id && e.parallelGroupId && e.parallelGroupId === entry.parallelGroupId);
  return <label className="pp-sched-parallel">Run alongside…<Select size="small" aria-label={`Run alongside ${entry.name}`} disabled={disabled||entries.some(e=>e.parallelGroupId===entry.parallelGroupId&&e.parallelGroupId&&(e.locked||protectedIds.has(e.id)))} value={peer?.id || ''} onChange={id => onChange(groupActivity(entries, entry.id, id))} options={[{ value: '', label: 'Sequential' }, ...entries.filter(e => e.id !== entry.id && e.kind === 'activity' && !e.locked && !protectedIds.has(e.id)).map(e => ({ value: e.id, label: e.name || 'Activity' }))]} /></label>;
}